const state = {
  snack: {
    active: false,
    timeout: 1500,
    color: '',
    text: ''
  }
}
  
const getters = {
  GET_SNACK (state) {
    return state.snack
  },
}
  
const actions = {
  INITIALIZE_SNACK ({state, commit}) {
    commit('SET_SNACK_OPTIONS', {
      active: state.snack.active,
      timeout: state.snack.timeout,
      color: state.snack.color,
      text: state.snack.text
    })
  },
  RESET_SNACK ({commit}) {
    commit('SET_SNACK_OPTIONS', {
      active: false,
      color: '',
      timeout: 1500,
      text: ''
    })
  }
}
  
const mutations = {    
  SET_SNACK_OPTIONS (state, options) {
    state.snack.active = options.active
    state.snack.timeout = options.timeout
    state.snack.color = options.color
    state.snack.text = options.text
  }
}
  
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}